<div class="topnav d-block d-sm-none" >
  <img src="../../../assets/imgs/logoT.png" width="150px" alt="Melhor PDV online">
  <!-- Navigation links (hidden by default) -->
  <div id="myLinks">
    <p class='ml-3' style="color: white;cursor: pointer;" (click)="scrollGarantia()"> Garantia</p>
    <p class='ml-3' style="color: white;cursor: pointer;"  (click)="scrollAssinaura()"> Preços</p>
    <p class='ml-3' style="color: white;cursor: pointer;"  (click)="scrollFuncoes()"> Funcionalidades</p>
    <p class='ml-3' style="color: white;cursor: pointer;"  (click)="scrollFAQ()"> FAQ</p>
    <a
      (click)="textWhats()"
      class="btn btn-sm py-1 px-4  shadow  btn-success ml-3 mb-2"
      style="color: white; border-radius: 30px;font-size: large;"
    >
      <i class="fab fa-whatsapp" ></i> {{contatoTelWhats}}
      <br/>
    </a>
  </div>
  <!-- "Hamburger menu" / "Bar icon" to toggle the navigation links -->
  <a  class="icon" (click)="abreMenu()" >
    <i class="fa fa-bars"></i>
  </a>
</div>

<div
  class="navbar mt-0 d-none d-sm-block"
  style="
    background-image: linear-gradient(
      to right,
      rgba(236, 173, 62, 0.932),
      rgba(255, 136, 14, 0.95)
    );
  "
>
  <div class="row">
    <div class="col-md-4 offset-md-1">
      <img
        src="../../../assets/imgs/logoT.png"
        alt="Yourder PDV e cardápio online"
        class="img-fluid"
        style="padding: 0; max-height: 80px; max-width: auto"
      />
    </div>
    <!-- -->
    <div class="col-md-7 mr-auto ml-0 offset-md-2" style="align-self: center">
      <div class="row">
        <p
          class="navigation-link w-nav-link"
          style="color: white;cursor: pointer;"
          (click)="scrollGarantia()"
        >
          Garantia
        </p>
        <p
          class="navigation-link w-nav-link ml-3"
          style="color: white;cursor: pointer;"
          (click)="scrollAssinaura()"
        >
          Preços
        </p>

        <p
        class="navigation-link w-nav-link ml-3"
        style="color: white;cursor: pointer;"
        (click)="scrollFuncoes()"
      >
        Funcionalidades
      </p>

      <p
      class="navigation-link w-nav-link ml-3"
      style="color: white;cursor: pointer;"
      (click)="scrollFAQ()"
    >
      FAQ
    </p>

      <a
      (click)="textWhats()"
      class="btn btn-sm py-1 px-4  shadow  btn-success ml-3"
      style="color: white; border-radius: 30px;font-size: large;align-self: center;"
    >
      <i class="fab fa-whatsapp" ></i>  {{contatoTelWhats}} <br />
    </a>
      </div>
    </div>
  </div>
</div>

<section class="pt-4 pt-md-5 pb-5 pb-md-6 section">
  <div class="bg">
    <div class="container">
      <div class="row mt-4">
        <div class="col-md-6" id="h1Entrada">
          <h1 style="text-align: left;font-weight: 700;">
            Seu PDV online com cardápio digital de delivery para<br> <span id="tw" style="font-weight: 800;"></span>.
          </h1>
          <p class="pt-3" style="color: rgb(37, 37, 37);font-size: large;font-weight: 600;"
            ><b
              >Sem comissões por pedidos, fidelize seu cliente diretamente em
              seu negócio .</b
            ></p>
          <p class="mt-4" style="color: rgb(60, 60, 60);font-size: medium;font-weight: 500;">
            Com o Yourder além de ter seu menu de pedidos na web, você terá toda
            gestão do seu negócio, no celular ou no computador !
          </p>
          <div class="row d-flex justify-content-center">
            <button

            id="whatsCall"
            class="btn btn-lg button mt-2"
            style="
              background-color: #218838;
              color: white;
              font-size: x-large;
              border-radius: 15px;
              max-width: 500px;
              height: auto;
              margin-bottom: 30px;
            "
            (click)="textWhats()"
            (mouseenter)="mouseEnter()"
            (mouseleave)="mouseLeave()"
          >
          <i class="fab fa-whatsapp " ></i> Quero saber mais!!
          </button>
          </div>

        </div>

        <div class="col-md-6 col-xs-12" style="height: 360px">
          <iframe
            [src]="safeURL"
            frameborder="0"
            allowfullscreen
            style="width: 100%; height: 100%"
          ></iframe>


        </div>
      </div>
    </div>
  </div>
</section>
<section
  id="FuncionalidadesId"
  class="block-section section-content pt-5 pt-md-6 pb-5 pb-md-6"
  style="background-color: transparent; background-size: cover"
>
  <div style="margin-left: 10%; margin-right: 10%">
    <div class="pl-0 pr-0">
      <div class="row">
        <div class="col-md-10 offset-md-1" id='beneficios' >
          <h2 class="text-center mb-4" style="">
            Quais os benefícios de ter o PDV do Yourder em seu negócio?
          </h2>
        </div>
        <div class="col-md-5 offset-md-2" id="estabelecimento" style="opacity: 1">
          <h3>Para seu estabelecimento</h3>
          <ul class="fa-ul styled-list mt-4">
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Sem limite de pedidos ou produtos!</span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Sistema de estoque</span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style="">
                Seu próprio menu online integrado com o sistema
              </span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Relatórios Mensais e Diarios. </span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Sistema de comandas por mesa. </span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Cancelamento a qualquer momento sem taxa. </span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style="">
                Integração com Pic Pay para pagamento online.
              </span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Agilidade no atendimento via WhatsApp. </span>
            </li>

            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Sistema de cupom de desconto. </span>
            </li>

            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Cadastro de contas a pagar. </span>
            </li>
          </ul>
        </div>
        <div class="col-md-5" id="cliente" style="opacity: 1;">
          <h3>Para seu cliente</h3>
          <ul class="fa-ul styled-list mt-4">
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Menu completo e padronizado</span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style="">
                Autonomia para realizar o pedido com alguns cliques
              </span>
            </li>
            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Cupom de desconto </span>
            </li>

            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style="">
                Possibilidade de pagamento online via Pic Pay
              </span>
            </li>

            <li class="mb-3">
              <span class="fa-li">
                <i class="fas fa-check text-primary"></i>
              </span>
              <span style=""> Possibilidade de agendamento de entrega </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<hr />
<section
  class="block-section d-block pt-5 pt-md-6 pb-5 pb-md-6"
  style="background-color: transparent; background-size: cover"
>
  <div style="margin-left: 5%; margin-right: 5%">
    <div class="pl-0 pr-0">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h2 class="text-center mb-4" style="">
            Motivos Para Você Utilizar o Yourder em seu restaurante
          </h2>
          <p class="lead text-center mb-5" style="">
            Tenha total controle sobre seu negócio, desde a cozinha até o
            delivery.
          </p>
        </div>
        <div class="col-md-12">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-4 px-md-4">
              <div class="card shadow-lg p-4 mb-3">
                <div class="text-center">
                  <i
                    class="fas fa-motorcycle Array mb-3"
                    style="color: #dd9933; font-size: xx-large"
                  ></i>
                </div>
                <h3 class="mt-0 mb-3 text-center" style="color: #444444">
                  Seu próprio Delivery
                </h3>
                <div class="font-size-85 mb-0">
                  <p style="text-align: center">
                    Tenha seu próprio delivery, sem taxas de comissão ou
                    pegadinhas. Sistema de menu online com sua marca e seu QR
                    Code.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 px-md-4">
              <div class="card shadow-lg p-4 mb-3">
                <div class="text-center">
                  <i
                    class="fab fa-whatsapp Array mb-3"
                    style="color: #dd9933; font-size: xx-large"
                  ></i>
                </div>
                <h3 class="mt-0 mb-3 text-center" style="color: #444444">
                  Mensagens automáticas
                </h3>
                <div class="font-size-85 mb-0">
                  <p style="text-align: center">
                    Configure mensagens automáticas para enviar via whatsapp na
                    confirmação do pedido e na saida para entrega.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 px-md-4">
              <div class="card shadow-lg p-4 mb-3">
                <div class="text-center">
                  <i
                    class="fas fa-clipboard-list Array mb-3"
                    style="color: #dd9933; font-size: xx-large"
                  ></i>
                </div>
                <h3 class="mt-0 mb-3 text-center" style="color: #444444">
                  Tudo em um só lugar
                </h3>
                <div class="font-size-85 mb-0">
                  <p style="text-align: center">
                    Gerencie, seu menu online, seus pedidos via whatsapp e seus
                    pedidos no balcão ou mesa em um sistema só . Com relatórios
                    diários e mensais.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section
  id="block-168"
  class="block-section section-content d-block pt-5 pt-md-6 pb-2 pb-md-3"
  style="background-color: #ff880e; background-size: cover"
>
  <div class="block-container orbit-container-lg">
    <div class="pl-0 pr-0">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h2 class="text-center mb-5" style="color: #ffffff">
            Veja uma demonstração do sistema.
          </h2>
        </div>
        <div class="col-md-6 offset-md-3" style="min-height: 400px">
          <iframe
            [src]="safeURL1"
            frameborder="0"
            allowfullscreen
            style="width: 100%; height: 100%"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</section>
<section id='faqId'
  class="block-section section-content d-block pt-5 pt-md-6 pb-4 pb-md-5"
  style="background-color: transparent; background-size: cover"
>
  <div style="margin-right: 10%; margin-left: 10%">
    <div class="pl-0 pr-0">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h2 class="text-center mb-3 mb-md-5" style="">
            Ainda com dúvidas?
          </h2>
          <h3 class="text-center mb-2">Vejas as principais questões abaixo:</h3>
        </div>
        <div class="col-md-8 offset-md-2">
          <div class="accordion" id="accordion-id">
            <div class="card p-0 shadow-lg">
              <div class="card-header px-4 py-3" style="cursor: pointer">
                <h4
                  class="my-1"
                  data-toggle="collapse"
                  data-target="#collapse-id-0"
                  aria-expanded="false"
                  aria-controls="collapse-id-0"
                  style=""
                >
                  Como funciona?
                </h4>
              </div>
              <div
                id="collapse-id-0"
                class="collapse"
                aria-labelledby="heading-id-0"
                data-parent="#accordion-id"
              >
                <div class="card-body p-4">
                  <p>
                    O Yourder é um sistema online para construção e gerenciamento de pedidos de seu restaurante, ele trás varias ferramentas que irão te ajudar no dia a dia, tanto nos pedidos via whatsapp, telefone ou seu cárdapio online
                  </p>
                </div>
              </div>
            </div>
            <div class="card p-0 shadow-lg">
              <div class="card-header px-4 py-3" style="cursor: pointer">
                <h4
                  class="my-1"
                  data-toggle="collapse"
                  data-target="#collapse-id-1"
                  aria-expanded="false"
                  aria-controls="collapse-id-1"
                  style=""
                >
                  Tenho uma garantia?
                </h4>
              </div>
              <div
                id="collapse-id-1"
                class="collapse"
                aria-labelledby="heading-id-1"
                data-parent="#accordion-id"
              >
                <div class="card-body p-4">
                  <p>
                    As assinaturas são vigentes a partir do pagamento, podendo
                    ser canceladas em até 7 dias do primeiro pagamento com
                    devolução total, ou canceladas antes dos vencimentos. O
                    cancelamento não tem nenhuma taxa e nem pegadinhas.
                  </p>
                </div>
              </div>
            </div>
            <div class="card p-0 shadow-lg">
              <div class="card-header px-4 py-3" style="cursor: pointer">
                <h4
                  class="my-1"
                  data-toggle="collapse"
                  data-target="#collapse-id-2"
                  aria-expanded="false"
                  aria-controls="collapse-id-2"
                  style=""
                >
                  Como posso realizar a assinatura?
                </h4>
              </div>
              <div
                id="collapse-id-2"
                class="collapse"
                aria-labelledby="heading-id-2"
                data-parent="#accordion-id"
              >
                <div class="card-body p-4">
                  <p>
                  Fale com um de nossos atendentes, ajudaremos a tirar todas as duvidas e auxiliar nos primeiros acessos. Após realizar a assinatura, seu login é liberado imediatamente para acesso na plataforma.

                  </p>
                </div>
              </div>
            </div>


            <div class="card p-0 shadow-lg">
              <div class="card-header px-4 py-3" style="cursor: pointer">
                <h4
                  class="my-1"
                  data-toggle="collapse"
                  data-target="#collapse-id-5"
                  aria-expanded="false"
                  aria-controls="collapse-id-5"
                  style=""
                >
                  Recebo um e-mail com a confirmação da assinatura?
                </h4>
              </div>
              <div
                id="collapse-id-5"
                class="collapse"
                aria-labelledby="heading-id-5"
                data-parent="#accordion-id"
              >
                <div class="card-body p-4">
                  <p>
                    Após a confirmação do pagamento da assinatura, você irá
                    receber um e-mail com seu login e senha depois de alguns
                    minutos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section
  id="block-192"
  class="block-section section-content d-block pt-4 pt-md-5 pb-4 pb-md-5"
  style="background-color: #ff880e; background-size: cover"
>
  <div style="margin-left: 10%; margin-right: 10%">
    <div class="pl-0 pr-0">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h2 class="text-center mb-4" style="color: #ffffff">
            Quero saber mais sobre o PDV Yourder
          </h2>
          <p class="lead text-center mb-4" style="color: #f1f0f0">
            Clique no botão abaixo e fale com o time Yourder!
          </p>
        </div>
        <div class="col-md-4 offset-md-4">
          <a
            (click)="textWhats()"
            class="btn btn-lg py-3 shadow h2 hvr-grow btn-block btn-success"
            style="color: white"
          >
            <i class="fab fa-whatsapp"></i> Chamar no WhatsApp <br />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!--


<section
  class="block-section section-content d-block pt-5 pt-md-6 pb-4 pb-md-5"
  id="assinaturaId"
  style="background-color: transparent; background-size: cover"
>
  <div class="block-container" style="margin-right: 10%; margin-left: 10%">
    <div class="pl-0 pr-0">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h1 class="text-center mb-4" style="">Aproveite essa oferta!</h1>
          <p class="lead text-center mb-5" style="">
            Assine agora nos planos abaixos
          </p>
        </div>
        <div class="col-md-12">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-4 px-md-4">
              <div class="card shadow-lg p-4 mb-3">
                <h3 class="mb-3 mt-0 text-center" style="">Plano Mensal</h3>
                <h4 class="text-danger text-center my-0">
                  <del>
                    <small class="font-weight-bold">De</small>
                    R$ 110,00
                  </del>
                </h4>
                <h2 class="text-success text-center mt-0 mb-3">
                  <small class="font-weight-bold">Por</small>
                  R$ 79,90
                </h2>

                <div class="text-center">
                  <a
                    routerLink="/assinatura/mensal"
                    class="
                      btn btn-lg
                      h4
                      hvr-grow-shadow
                      px-4
                      py-2
                      mt-3
                      shadow
                      btn-success
                    "
                  >
                    Quero este
                  </a>
                </div>
              </div>
            </div>

            <div class="col-md-4 px-md-4">
              <div class="card shadow-lg p-4 mb-3">
                <div class="ribbon ribbon-top-right"><span>+30% OFF</span></div>
                <h3 class="mb-3 mt-0 text-center" style="">Plano Semestral</h3>
                <h4 class="text-danger text-center my-0">
                  <del>
                    <small class="font-weight-bold">De</small>
                    R$ 660,00
                  </del>
                </h4>
                <h2 class="text-success text-center mt-0 mb-3">
                  <small class="font-weight-bold">Por</small>
                  R$ 447,70
                </h2>

                <div class="text-center">
                  <a
                    routerLink="/assinatura/semestral"
                    class="
                      btn btn-lg
                      h4
                      hvr-grow-shadow
                      px-4
                      py-2
                      mt-3
                      shadow
                      btn-success
                    "
                  >
                    Quero Este
                  </a>
                </div>
              </div>
            </div>

            <div class="col-md-4 px-md-4">
              <div class="card shadow-lg p-4 mb-3">
                <div class="ribbon ribbon-top-right"><span>+40% OFF</span></div>
                <h3 class="mb-3 mt-0 text-center" style="">Plano Anual</h3>
                <h4 class="text-danger text-center my-0">
                  <del>
                    <small class="font-weight-bold">De</small>
                    R$ 1320,00
                  </del>
                </h4>
                <h2 class="text-success text-center mt-0 mb-3">
                  <small class="font-weight-bold">Por</small>
                  R$ 777,70
                </h2>

                <div class="text-center">
                  <a
                    routerLink="/assinatura/anual"
                    class="
                      btn btn-lg
                      h4
                      hvr-grow-shadow
                      px-4
                      py-2
                      mt-3
                      shadow
                      btn-success
                    "
                  >
                    Quero Este
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<hr />
<section id='garantiaId'
  class="block-section section-content d-block pt-4 pt-md-5 pb-4 pb-md-5"
  style="background-color: #ffffff"
>
  <div style="margin-left: 10%; margin-right: 10%">
    <div class="pl-0 pr-0">
      <div class="row align-items-center">
        <div class="col-md-4 order-md-last">
          <img
            src="../../../assets/imgs/garantia.png"
            alt=""
            class="img-fluid d-block px-4 px-md-0 mx-auto mb-3 mb-md-0"
          />
        </div>
        <div class="col-md-8 pr-md-5">
          <h1 class="mb-4" style="">Garantia de 7 dias para devoluções!</h1>
          <p>
            Para manter a credibilidade conquistada, a empresa garante uma
            política de devolução simplificada de acordo com o Código de Defesa
            do Consumidor. Se ao assinar, você resolver cancelar, você poderá
            fazê-lo em até 07 (sete) dias corridos, a contar da data da
            assinatura. Comunique ao nosso Serviço de Atendimento ao Consumidor
            (SAC) através do endereço eletrônico contato@yourder.com.br ,
            informe o ocorrido e em 48 horas receberá um retorno.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
-->
<section
  class="block-section pt-2 pt-md-2 pb-2 pb-md-3"
  style="background-color: #3060b4; background-size: cover"
>
  <div style="margin-right: 10%; margin-left: 10%">
    <div class="pl-0 pr-0 text-center">
      <br />
      <p class="font-size-75 opacity-75 mt-2 mb-0" style="color: #dddddd">
        © {{year}} - Yourder. Todos direitos reservados - CNPJ: 43.395.290/0001-22
      </p>
    </div>
  </div>
</section>
